import { ImageLink } from '@graphql/index';
import { CleanContentful } from '@stadionhq-v3/clean-contentful';
import { Locale } from '@core/constants/locales.constants';
import { ContentfulImage } from '@stadionhq-v3/contentful-ui';
import { linkTransform } from './link.transform';

export const imageLinkTransform = (
  imageLink: CleanContentful<ImageLink>,
  locale: Locale
) =>
  imageLink?.link && {
    id: imageLink.id,
    ...(imageLink?.link?.url
      ? linkTransform(imageLink.link, locale)
      : undefined),
    logo: imageLink.image && <ContentfulImage {...imageLink.image} />,
  };
